import React from 'react';
import { GridLoader } from 'react-spinners';
import '@/stylesheets/CommonLoadingView.scss';
//
export default function CommonLoadingView({ isLoading, isFixed }) {
  const loadingClass = `${isLoading ? '' : 'hide '}loading${isFixed != undefined ? ' loadingLogin' : ''}`;
  return (
    <div className={loadingClass}>
      <div className='loadingWheel'>
        <GridLoader sizeUnit="px" size={20} color='#454545'
                    loading={isLoading}/>
      </div>
    </div>
  );
}
